import { isUrlInDomainList } from '@/hooks/useRequiredInterceptor';
import { syncGntcConfig } from '@/utils/syncGntcConfig';
import axios from 'axios';
import React from 'react';

export const useOidcHeaderInterceptor = ({
  accessToken,
  trustedDomains,
}: {
  accessToken?: string;
  trustedDomains: string[];
}) => {
  const accessTokenRef = React.useRef('');

  // Update Reference used inside interceptor
  React.useEffect(() => {
    if (!accessToken) return;

    accessTokenRef.current = accessToken;
  }, [accessToken]);

  // Interceptor
  React.useEffect(() => {
    const ejectId = axios.interceptors.request.use((config) => {
      if (!isUrlInDomainList(config.url, trustedDomains)) return config;

      const { data = {} } = config;

      if (accessTokenRef.current) {
        data.ssoToken = accessTokenRef.current;
      }

      return {
        ...config,
        data,
      };
    });

    syncGntcConfig();

    return () => {
      axios.interceptors.request.eject(ejectId);
      syncGntcConfig();
    };
  }, [trustedDomains]);
};
